module.exports = __webpack_public_path__ + "static/img/photo-5.2f032074.jpg";